import { render, staticRenderFns } from "./MarsUser.vue?vue&type=template&id=251c04b5&scoped=true&"
import script from "./MarsUser.vue?vue&type=script&lang=js&"
export * from "./MarsUser.vue?vue&type=script&lang=js&"
import style0 from "./MarsUser.vue?vue&type=style&index=0&id=251c04b5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251c04b5",
  null
  
)

export default component.exports